export const slideToLeft = {
  initial: { opacity: 0, x: -window.innerWidth },
  animate: { opacity: 1, x: 0 },
  transition: (i = 0) => ({
    delay: 0.5 + i * 0.1,
    duration: 1,
    type: "spring"
  }),
};

export const slideToRight = {
  initial: { opacity: 0, x: window.innerWidth  },
  animate: { opacity: 1, x: 0 },
  transition: (i = 0) => ({
    delay: 0.5 + i * 0.1,
    duration: 1,
    type: "spring"
  }),
   
};
export const popUp = {
  initial: { opacity: 0, scale: 0, zIndex: 10 },
  animate: { opacity: 1, scale: 1, zIndex: 10 },
  transition: () => ({
    delay: 0.5,
    duration: 1.5,
    type: "spring",
    bounce: 0.4
  }),
};

// shaking animation
export const shakeAnimation = {
  animate: {
    x: [0, -3, 3, -3, 3, 0],
    transition: {
      duration: 1,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  },
  stop: {
    x: 0
  }
};
